exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/main/main.scss
// module id = 1058
// module chunks = 1